/** Defines the shared brand-item Request Action catalogue and problem payload builder. */
import {BrandItemProblemInput} from "../../../Queries";

export const BRAND_ITEM_REQUEST_ACTIONS = [
   {code: "RETAKE_PHOTOS", title: "Retake photos", description: "Request new photos of the item"},
   {code: "REPAIR", title: "Request repair", description: "Item needs repair or maintenance."},
   {code: "WASH", title: "Request wash", description: "Item needs cleaning."},
   {code: "DISCARD", title: "Discard item", description: "Item cannot be sold or used."},
   {code: "DONATE", title: "Donate item", description: "Donate item to charity."},
   {code: "SEND_TO_BRAND", title: "Send to brand", description: "Item will be shipped to the brand."},
   {code: "PAUSE", title: "Pause item", description: "Item will be taken offline temporarily"},
   {code: "OTHER", title: "Other", description: "Other action required, supply details below"}
] as const;

export type BrandItemRequestActionCode = typeof BRAND_ITEM_REQUEST_ACTIONS[number]["code"];

/** Creates the unsolved problem persisted by both Request Action surfaces. */
export const buildBrandItemActionProblem = (
   code: BrandItemRequestActionCode,
   details: string,
   createdAt: Date = new Date()
): BrandItemProblemInput => {
   const action = BRAND_ITEM_REQUEST_ACTIONS.find(candidate => candidate.code === code);
   if (!action) {
      throw new Error(`Unsupported Request Action: ${code}`);
   }
   const trimmedDetails = details.trim();
   return {
      description: trimmedDetails ? `${action.title}: ${trimmedDetails}` : action.title,
      solved: false,
      createdAt
   };
};
